import "./scrollTop.css";
import { useHomeContent } from "../../../pages/Landing/hooks/useHomeContent";

export const ScrollTop = () => {
  const data = useHomeContent();
  const label = data?.scrollTop?.label ?? data?.common?.scrollTopLabel ?? "";

  return (
    <div className="oc-scrollTop">
      <button
        className="oc-scrollTop__btn"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        type="button"
      >
        {label}
      </button>
    </div>
  );
};
